import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const FindPasswordSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Email,
    id: "email",
    label: "이메일",
    placeholder: "이메일을 입력하세요.",
    behavior: {
      required: true,
    },
  },
];
